import { useStore } from 'vuex'
import ContentCarousel from '../ContentCarousel/ContentCarousel.vue'

export default {
    name: "FeaturedGroups",
    components: {
        ContentCarousel
    },
    props: {
        colorTheme: {
            type: String,
            required: false
        },
        groupsList: {
            type: Object,
            required: false
        },
        hasGroupsButton: {
            type: Object,
            required: true
        },
        noGroupsButton: {
            type: Object,
            required: true
        },
        sliderContentJson: {
            type: Object,
            required: true
        },
        sliderId: {
            type: String,
            required: true
        }

    },
    setup(){
        const store = useStore()

        const getLabel = (labelKey, replacements) => {
            let label = store.getters['labels/getLabel']({ labelCollection: 'FeaturedGroups', labelKey: labelKey })
            if (replacements) {
                replacements.forEach((replacement, index) => {
                    label = label.replace(`{${index}}`, replacement)
                })
            }
            return label
        }

        return {
            getLabel
        }

    }
}